import { styled, useTheme } from '@mui/material/styles';
import colors from '../../assets/colors';
import { Modal, Fade, Box, IconButton } from '@mui/material';
import { Cancel } from '@mui/icons-material';

const CustomModal = styled(Modal)({
  border: `1px solid ${colors.oldAgroweGreen}`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  outline: 'none',
});

export default function StyledModal(props) {
  const theme = useTheme();
  return (
    <CustomModal open={props.open}>
      <Fade in={props.open}>
        <Box
          justifyContent="center"
          alignItems="center"
          sx={{
            position: 'relative',
            textAlign: 'center',
            backgroundColor: theme.palette.background.paper,
            border: `3px solid ${colors.oldAgroweGreen}`,
            borderRadius: 4,
            boxShadow: theme.shadows[5],
            outline: 'none',
            px: 8,
            py: 3,
          }}
        >
          <IconButton
            onClick={props.handleClose}
            sx={{
              color: colors.redButton,
              position: 'absolute',
              top: 5,
              right: 5,
            }}
            aria-label="closeButton"
          >
            <Cancel />
          </IconButton>
          {props.children}
        </Box>
      </Fade>
    </CustomModal>
  );
}
